<template>
  <div class="voice">
    <div class="voice_title van-ellipsis">
      <span style="margin-right: 4px">—&nbsp;来自</span>
      <span class="voice_title_name van-ellipsis">{{ messageDetail.doctorName }}</span>
      <span>医生&nbsp;{{ messageDetail.createTime }}</span>
      <span style="margin-left: 4px">—</span>
    </div>
    <div class="voice_content" @click="precessPlayVoice">
      <span class="voice_content_time">
        <img v-if="isPlaying" width="14px" height="16px" :src="require('@/assets/imgs/voice/voice.gif')" alt="" />
        <img v-else width="14px" height="16px" :src="require('@/assets/imgs/voice/yuyin.png')" alt="" />
        <span style="margin-left: 8px">{{ messageDetail.audioLength }}</span>
      </span>
    </div>
  </div>
</template>
<script>
import utils from '@/util/index.js';
import BenzAMRRecorder from 'benz-amr-recorder';
export default {
  name: 'voicePlay',
  data() {
    return {
      // attr: require('./c7b32d0ea62b4248b894ac7f2d3bf14ec03186b3b64ce8669f07ba63229693a9.amr'),
      messageDetail: {
        audioLength: 0,
        doctorName: '',
        createTime: ''
      },
      duration: '',
      isPlaying: false,
      mediaId: '',
      localId: '',
      playTimer: null,
      amr: null
    };
  },
  mounted() {
    const { content, audioLength, doctorName, createTime, url } = this.$route.query;

    this.messageDetail = {
      audioLength: audioLength ? utils.toHHmmss(audioLength * 1000, 'en').slice(3) : '00:00',
      doctorName,
      createTime,
      url
    };
    this.duration = audioLength;
    this.mediaId = content;
    window.wx.downloadVoice({ serverId: content }).then((res) => {
      this.localId = res.localId;
      // alert(res.localId || 'localId 不存在');
    });
  },
  methods: {
    stopPlayVoice() {
      if (this.amr.isPlaying()) {
        this.amr.stop();
        this.isPlaying = false;
      }
    },

    async precessPlayVoice() {
      if (this.amr !== null) {
        this.stopPlayVoice();
      }

      this.amr = new BenzAMRRecorder();

      this.amr
        .initWithUrl(this.messageDetail.url) //初始化
        .then(() => {
          this.isPlaying = true;
          this.amr.play(); //播放

          this.amr.onEnded(() => {
            this.isPlaying = false;
          });
        })
        .catch((e) => {
          this.isPlaying = false;
          this.$toast('播放语音失败');
        });

      // audio.play();

      // if (!this.localId) {
      //   this.$toast('语音加载失败请刷新重试');
      //   return;
      // }
      // this.playTimer = null;

      // if (!this.isPlaying) {
      //   this.isPlaying = true;
      //   audio.play();
      //   // window.wx.playVoice({ localId: this.localId }).then((res) => {
      //   //   if (res.localId === this.localId) {
      //   //     this.isPlaying = false;
      //   //   }
      //   // });
      //   // this.initPlayTimer();
      // } else {
      //   // window.wx.stopVoice({ localId: this.localId });
      //   audio.stop();
      //   this.isPlaying = false;
      // }
    },
    initPlayTimer() {
      if (this.duration) {
        this.playTimer = setTimeout(() => {
          if (this.isPlaying) {
            this.isPlaying = false;
          }
        }, this.duration);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.voice {
  height: 100vh;
  background: #ffffff;
  text-overflow: ellipsis;
  &_title {
    display: flex;
    margin: 0 16px;
    font-size: 12px;
    color: #bfbfbf;
    line-height: 40px;
    justify-content: center;
    &_name {
      // flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  &_content {
    width: 343px;
    height: 48px;
    margin: 0 auto;
    background: #f7f7f7;
    border-radius: 4px;
    padding: 0 16px;
    &_time {
      font-size: 12px;
      color: #262626;
      line-height: 48px;
      display: flex;
      align-items: center;
    }
  }
}
.box {
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  position: relative;
  margin: 50px auto;
  .wifi-symbol {
    width: 50px;
    height: 50px;
    box-sizing: border-box;
    overflow: hidden;
    transform: rotate(135deg);
  }
  .wifi-circle {
    border: 3px solid #1aad1a;
    border-radius: 50%;
    position: absolute;
  }
  .first {
    width: 5px;
    height: 5px;
    background: #cccccc;
    top: 45px;
    left: 45px;
  }

  .second {
    width: 25px;
    height: 25px;
    top: 35px;
    left: 35px;
    animation: fadeInOut 1.5s infinite 0.2s;
  }

  .third {
    width: 40px;
    height: 40px;
    top: 25px;
    left: 25px;
    animation: fadeInOut2 1.5s infinite 0.6s;
  }
  .stop {
    animation-play-state: paused;
  }

  @keyframes fadeInOut {
    0% {
      opacity: 0; /*初始状态 透明度为0*/
    }
    1% {
      opacity: 1;
    }
    58% {
      opacity: 1; /*结尾状态 透明度为1*/
    }
    59% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes fadeInOut2 {
    0% {
      opacity: 0; /*初始状态 透明度为0*/
    }
    1% {
      opacity: 1;
    }
    30% {
      opacity: 1; /*结尾状态 透明度为1*/
    }
    31% {
      opacity: 0; /*结尾状态 透明度为1*/
    }

    100% {
      opacity: 0; /*结尾状态 透明度为1*/
    }
  }
}
</style>
